import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  takeUntil,
  tap,
} from 'rxjs';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import Swal from 'sweetalert2';
import { UserModel, UserTableFields } from '../../models/vet-users/user.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { UserFacade } from '../../shared-new/store/user-management/user.facade';
import { UserManagementDataSource } from '../user-management-datasource';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  public users: UserModel[];
  public dataSource: UserManagementDataSource;
  public displayedColumns$ = new BehaviorSubject([
    'userImage',
    'username',
    'memberName',
    'emailId',
    'userRole',
    'phoneNumber',
    'action',
  ]);
  public isLoader: boolean = false;
  public userTableFields = UserTableFields;

  users$ = this.userFacade.users$;
  usersError$ = this.userFacade.usersError$;
  usersLoading$ = this.userFacade.usersLoading$;
  success$ = this.userFacade.success$;
  public searchTerm: string;
  public constructor(
    private readonly router: Router,
    private userFacade: UserFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private toastService: ToastService
  ) {
    super();
  }
  private attachEvents() {
    this.users$.pipe(takeUntil(this.unsubscribe$)).subscribe((users) => {
      if (users) {
        const totalRecords = [...users];
        this.dataSource = new UserManagementDataSource(users, totalRecords);
        if (this.searchTerm) {
          this.dataSource.searchTable(this.searchTerm);
        }
      }
    });
    this.usersLoading$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((loading) => {
        this.isLoader = loading;
      });
    this.usersError$.pipe(takeUntil(this.unsubscribe$)).subscribe((err) => {
      if (err) {
        this.httpErrorHandlerService.ShowErrorMessage(err);
      }
    });
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.forgot) {
        this.toastService.success(
          "We've sent an email to the address associated with this user"
        );
      }
    });
  }
  public updateResetPassword(user: UserModel): void {
    Swal.fire({
      title: 'Send Reset Password',
      text: 'Do you want to Reset the Password?',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Resest',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.value) {
        this.userFacade.forgotPasswordByUserId(user.userId);
      }
    });
  }
  public ngAfterViewInit(): void {
    //fromEvent(this.searchInput.nativeElement, 'keyup')
    //  .pipe(
    //    debounceTime(50),
    //    distinctUntilChanged(),
    //    takeUntil(this.unsubscribe$),
    //    tap(() => {
    //      const term = this.searchInput.nativeElement.value;
    //      this.dataSource.searchTable(term);
    //    })
    //  )
    //  .subscribe();

    //if (this.searchTerm) {
    //  this.searchInput.nativeElement.value = this.searchTerm;
    //  this.dataSource.searchTable(this.searchTerm);
    //}
  }
  applyFilter(searchText: string) {
    this.searchTerm = searchText;
    this.dataSource.searchTable(searchText);
  }
  public isImageUrl(url: string): boolean {
    const imageExtensions = [
      '.jpg',
      '.jpeg',
      '.png',
      '.gif',
      '.bmp',
      '.svg',
      '.webp',
    ]; // Add more extensions if needed

    const lowercasedUrl = url.toLowerCase();
    return imageExtensions.some((ext) => lowercasedUrl.endsWith(ext));
  }

  public goToAddEditPage(user: UserModel): void {
    if (user) {
      this.router.navigate(['/user-detail', user.userId]);
      return;
    }
    this.router.navigate(['/user-detail']);
  }

  public sortTable(sortBy: keyof UserModel): void {
    this.dataSource.sort(sortBy);
  }
  public onTableScroll(): void {
    if (!this.isLoader) {
      this.dataSource.onScroll();
    }
  }

  public ngOnInit(): void {
    this.userFacade.loadUsers();
    this.attachEvents();
  }
}
